// extracted by mini-css-extract-plugin
export var errorIcon = "_pe-1";
export var nameLogo = "_pe-0";